import { render, staticRenderFns } from "./FeedbackSubmitForm.vue?vue&type=template&id=4374bcac&scoped=true"
import script from "./FeedbackSubmitForm.vue?vue&type=script&lang=js"
export * from "./FeedbackSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSubmitForm.vue?vue&type=style&index=0&id=4374bcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4374bcac",
  null
  
)

export default component.exports